import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=685a435c&scoped=true"
var script = {}
import style0 from "./ArrowDown.vue?vue&type=style&index=0&id=685a435c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a435c",
  null
  
)

export default component.exports